/**
 * 점검 **행**의 수정 어포던스 판정 — 목록·스케줄의 행 메뉴가 같은 답을 보는 자리.
 *
 * ## 왜 이 파일이 있나 — 같은 식이 손으로 여러 벌 적혀 있었다
 *
 * `(소유자 성질 ∥ `inspection.manage` ∥ 본인) ∧ 이 현장에 닿을 수 있나` — 이 식이 2026-10-09까지
 * 행 렌더 루프마다 **손으로** 적혀 있었고, 스케줄 페이지에는 **아예 없었다**(그래서 권한 없는
 * 사람에게도 「보고서 생성」이 활성으로 보였다 — 서버가 생성 시 403으로 막으므로 거짓 어포던스다).
 *
 * ⚠️ **이 함수는 「무엇을 해도 되나」를 말하지 않는다.** 집행은 서버가 한다
 * (`PERMISSION_INSUFFICIENT_ROLE`·`SITE_NOT_ASSIGNED`·`PERMISSION_DENIED`). 여기서 정하는 것은
 * **버튼을 활성으로 보일지**이고, 그래서 서버보다 느슨해지면 거짓 어포던스가, 빡세지면 할 수 있는
 * 일이 숨는다.
 *
 * ## ⚠️⚠️ 보고서 생성 축에는 **쓰지 말 것** (2026-10-09 `a8061c0c4`)
 *
 * 이 식은 **집행보다 좁다.** 집행의 권한식은
 * `신원 축(그 점검의 활성 참가자 ∨ 주담당자) ∨ (현장 scope ∧ report.create)`인데(`reports.service.ts`
 * `:1316`·`:1329`, 서버가 `resolveCanCreateReport`로 그것을 미러해 `reportGate`에 싣는다) 이 함수는
 * **`(…) ∧ 현장 배정`**이라 **미배정 활성 참가자**를 막는다. prod 실측으로 그런 **46건**이 거짓
 * 차단되고 있었다(결정 `2026-10-09-the-enforcement-expression-is-the-canonical-gate.md` 결론 1).
 * ⇒ 그래서 `InspectionTable`의 보고서 축은 이 함수를 **떠났다**(삭제·검토요청은 그대로). 게이트를
 * **받는** 화면은 `reportGate`만 보면 된다 — 거기 이 함수를 AND하면 그 46건이 되살아난다.
 *
 * ⚠️ **스케줄은 예외이고 그것이 아래 표의 남은 하나다** — 그 화면은 `reportGate`를 **못 받으므로**
 * (게이트를 싣지 않는 응답 경로) 서버가 계산한 권한이 도달하지 않고, 이 함수가 **유일한 판정**이다.
 * 그래서 그 화면의 답은 목록보다 좁다(같은 46건을 거기서는 여전히 막는다 — 알려진 비대칭).
 * 🔖 되짚을 조건: `findInspectionSchedules`가 게이트를 싣게 되면 그 화면의 AND도 걷는다.
 *
 * ## ⚠️ 소비처 전수 — 수렴한 **둘**과 아직 손식인 **여섯** (2026-10-09 기준)
 *
 * ⚠️ 2026-10-09까지 이 표가 「사본이 **셋**」이라 적고 행이 「(2곳)」으로 뭉개져 있었다 —
 * `isSiteAssigned` 전수로 다시 세면 **여섯**이고, 더 중요한 것은 **그 여섯이 같은 식이 아니다**
 * (아래 ⚠️⚠️). 수를 고칠 때 「행위」 칸을 함께 보라 — 수만 맞으면 다음 사람이 또 일괄로 옮긴다.
 *
 * | 자리 | 쓰는 행위 | 식 | 상태 |
 * |---|---|---|---|
 * | `components/inspection/desktop/InspectionTable.tsx` | 삭제 · 검토 요청 (~~보고서 생성~~) | 3항 | ✅ 이 함수 |
 * | `pages/schedules/components/DayInspectionList.tsx` | **보고서 생성** | 3항 | ✅ 이 함수 |
 * | `InspectionListFold.tsx:193` · `InspectionListPhone.tsx:194` | **복원**(모달 `canRestore`) | **2항** | ❌ 손식 — **옮기지 말 것** |
 * | `InspectionListFold.tsx:227` · `InspectionListPhone.tsx:228` | 액션시트 삭제(+복원 **도달 불가**) | 3항 | ❌ 손식 |
 * | `InspectionListFold.tsx:366` · `InspectionListPhone.tsx:385` | 행 루프 삭제(스와이프) | 3항 | ❌ 손식 |
 *
 * ### 축별 소비 — 이 함수를 **부르는** 둘
 *
 * | 축 | 어디서 | 그 값이 흘러드는 곳 |
 * |---|---|---|
 * | **삭제** | `InspectionTable:418` → `canModify` | `canDelete={canModify}`(`:431`) |
 * | **검토 요청** | 같은 값 | `canRequestReview={canModify}`(`:433`) |
 * | **보고서 생성** | `DayInspectionList:339` → `hasReportPermission` | `canCreateReport`(`:347`) · 사유(`:349`) |
 *
 * ⚠️ **보고서 축의 소비는 그 한 곳뿐이다** — 목록은 2026-10-09에 떠났고(위 ⚠️⚠️), 그 자리에
 * 권한을 다시 물리는 되돌림의 **유일한 탐지기**는 `lib/__tests__/reportGate.test.ts` **⑬**이다
 * (⑫는 그 파일이 삭제 축으로 이 함수를 여전히 부르므로 **되돌려도 green**이다).
 * ⚠️ 그래서 **이 함수의 식을 고칠 때 축이 셋임을 기억할 것** — 삭제·검토요청 둘은 목록에,
 * 보고서 하나는 스케줄에 있고, 세 축이 같은 식을 공유한다(그것이 doc 머리의 「합치면 삭제 정책을
 * 바꿀 때 보고서 생성이 조용히 따라 움직인다」가 가리키는 위험이다).
 *
 * ### ⚠️⚠️ 손식 여섯 중 **복원 둘은 이 함수로 옮기면 안 된다** (2026-10-09 확인)
 *
 * 그 둘은 `isOwner || inspection.inspectorId === currentUserId`로 **현장 항이 없다**(2항식). 그 한
 * 축에서는 — **배정을 AND하지 않는다는 점에서만** — 집행과 같은 모양이고, 그것이 옮기면 안 되는
 * 이유다. 복원의 서버 집행은 `isParticipant ∨ resolveActor(…).canAct`이고
 * (`inspections.service.ts:1691~1700`, `canAct = isOwner ∨ (isAssigned ∧ hasKey)` —
 * `inspection-query.helper.ts:48`) **참가자 축에 현장 배정을 AND하지 않는다.** 이 함수로 옮기면 그
 * 축에 배정이 물려 **미배정 활성 참가자의 복원이 거짓 차단**되는데, 그것이 위 ⚠️⚠️의 보고서 축에서
 * prod **46건**으로 드러난 그 결함과 같은 모양이다.
 *
 * ⚠️ **「같은 모양」을 그 한 축 밖으로 넓혀 읽지 말 것** — 2항식은 집행과 **일치하지 않는다**.
 * 어긋난 두 축과 각각의 방향이 바로 아래 표다.
 *
 * ⚠️ 다만 「2항식 = 집행과 일치」는 **아니다**(그렇게 읽으면 다음 사람이 반대 방향으로 틀린다).
 * 두 축이 각각 어긋나 있는데 **방향이 다르고 그래서 무게도 다르다** — 프론트는 **UI 게이트**이고
 * 집행은 서버이므로, 프론트가 좁으면 **실피해**이고 넓으면 **UX 불량**이다(집행이 막는다):
 *
 * | 축 | 집행(서버) | 손식(프론트) | 방향 | 판정 |
 * |---|---|---|---|---|
 * | **참가자** | `isParticipant` = 활성 collaborator(역할 무관) ∨ `inspectorId` ∨ **`createdById`** | `inspectorId` 하나 | 프론트가 **좁다** | 🔴 **거짓 차단 — 실피해** |
 * | **관리** | `isAssigned ∧ hasKey` | 키만(배정 AND 없음) | 프론트가 **느슨하다** | 🟡 **거짓 허용 — 서버가 403으로 막으므로 UX** |
 *
 * 🔴 쪽이 위 ⚠️⚠️의 보고서 축에서 prod **46건**으로 드러난 그 결함과 **같은 방향**이다 —
 * 부담당 참가자·점검 작성자에게 복원 버튼이 **안 보이는데 서버는 허용한다.** 집행의 참가자 축은
 * **세 갈래**(`inspections.service.ts:3104~3117`)인데 손식은 그중 하나만 본다 — `createdById`가
 * 빠진 것이 특히 조용하다(점검을 만든 사람이 주담당자가 아닐 수 있다).
 * 🟡 쪽은 보안 구멍이 아니다. 고칠 값은 있지만 **급하지 않다**.
 *
 * ⚠️ **이 둘은 2026-10-09에 «고치지 않았다»** — 복원 게이트의 동작이 바뀌는 일이라 사용자 판단이
 * 필요하다. 이 표의 몫은 「무엇이 어긋났고 어느 방향인가」를 정확히 두는 것까지다.
 * 🔖 되짚을 조건 — **🔴를 겪는 사람이 prod에 실재하면** 그때 참가자 축을 집행과 같은 세 갈래로
 * 넓힌다(🟡은 그 결정에 딸려 판단). 재는 곳은 `inspection_collaborators` + `inspections`이고
 * 쿼리는 한 줄이다 — 「삭제된 점검 중, `inspectorId`가 아닌 활성 참가자나 작성자가 있는 것」:
 * ```sql
 * SELECT count(*) FROM inspections i WHERE i.deleted_at IS NOT NULL
 *   AND (i.created_by_id <> i.inspector_id OR EXISTS (
 *     SELECT 1 FROM inspection_collaborators c WHERE c.inspection_id = i.id
 *       AND c.left_at IS NULL AND c.excluded_at IS NULL AND c.user_id <> i.inspector_id));
 * ```
 * ⚠️ **[대조군]을 함께 셀 것** — 같은 쿼리에서 `deleted_at IS NULL`로 바꾼 값이 0이면 축이 틀린
 * 것이다(복원은 삭제된 점검에만 뜨므로 분모가 삭제분이지만, 그 형상이 **애초에 존재하는지**는
 * 전체에서 세야 안다).
 *
 * ⚠️ **액션시트 안의 복원 분기는 도달하지 않는다** — 그 분기(`if (isDeleted && onRestoreInspection)`)가
 * 3항식 `canModify`를 쓰지만, ⋯ 버튼 자체가 `{!isDeleted && (`로 가려져 있어(Fold`:402`·Phone`:462`)
 * `selectedInspection`이 삭제된 행일 수 없고 그 안의 `isDeleted`는 늘 false다. 즉 **산 복원 경로는
 * 2항식 하나**(모달 `canRestore` — Fold`:536`·Phone`:538`)다. 죽은 분기의 식을 근거로 「복원도 3항식을
 * 쓴다」고 읽지 말 것.
 *
 * 폰·폴드 목록에는 **「보고서 생성」 메뉴가 없다**(복원·삭제뿐)이라 이 라운드의 축이 아니었고, 같은
 * 식처럼 보여도 **묻는 행위가 다르므로** 함께 옮기는 것은 별 판단이다(합쳐 두면 삭제 정책을 바꿀 때
 * 복원·보고서 생성이 조용히 따라 움직인다).
 * 🔖 되짚을 조건: **삭제 축 넷**(3항식)은 묶어 옮길 수 있고, 폰·폴드 목록에 보고서 생성 메뉴가 생기면
 * 그때 그 축을 판단할 것. **복원 둘은 위 근거가 뒤집히지 않는 한 대상이 아니다** — 뒤집히는 조건은
 * 「서버 복원 집행이 참가자 축에도 현장 배정을 요구하게 되는 것」 하나다.
 *
 * ## 소유자 항을 밖에서 받는 이유
 *
 * `isOwner` 인자는 **「소유자 성질 ∥ `inspection.manage` 키」를 이미 합친 값**이다(호출부가
 * `usePermissions`로 만든다). 훅을 이 함수 안에서 부를 수 없는 것이 그 이유다 — 호출부가 전부
 * **행마다 `siteId`가 다른 렌더 루프 안**이라 순수 함수여야 한다(`utils/siteAccess.ts` doc의
 * 같은 사정).
 */
import { isSiteAssigned, type SiteAccessMembership } from './siteAccess';

export interface InspectionRowAccessInput {
  /** `/auth/me`의 `currentMembership` — 현장 배정·소유자 성질의 원천. */
  membership: SiteAccessMembership | null | undefined;
  /**
   * **소유자 성질 ∥ `inspection.manage`** 를 합친 값. 호출부가 `usePermissions`로 만든다
   * (`isOwner: isOrgOwner` + `canManageInspections`). 이름이 `isOwner`인 것은 소비처 호환용이다.
   */
  isOwner: boolean;
  /** 로그인 사용자 id. */
  currentUserId: string | undefined;
  /** 이 행의 주 담당자 userId(`PRIMARY` collaborator). */
  inspectorId: string | undefined;
  /** 이 행의 현장 id. */
  siteId: string | undefined;
}

/**
 * 이 점검 행을 수정할 수 있는 사람으로 보이나.
 *
 * ⚠️ **현장 항은 AND다.** 조직 관리 권한이 있어도 그 현장에 닿을 수 없으면 false다(소유자는
 * `isSiteAssigned`가 전 현장에서 true를 주므로 통과한다 — 그 근거는 `utils/siteAccess.ts` doc).
 * 점검 상세는 이 자리를 **OR**로 판정한다(`InspectionDetailDesktop`의 `canCreateReport` =
 * `isInspectorOrOwner || isSiteAssigned`) — 즉 **상세와 목록은 오늘 답이 갈릴 수 있다**(현장
 * 미배정 조직 관리자). 그 통일은 넓히거나 좁히는 결정이라 이 함수가 임의로 하지 않는다.
 * 🔖 되짚을 조건: 그 축을 통일하기로 하면 양쪽이 이 함수를 쓰게 할 것.
 */
export function canModifyInspectionRow({
  membership,
  isOwner,
  currentUserId,
  inspectorId,
  siteId,
}: InspectionRowAccessInput): boolean {
  if (!siteId) return false;
  const isOwnerOrInspector = isOwner || (!!currentUserId && inspectorId === currentUserId);
  return isOwnerOrInspector && isSiteAssigned(membership ?? null, siteId);
}
